export default __webpack_public_path__ + "static/media/loading_artwork.3cb0ea38.png";